import { inject } from '@angular/core';

import { provideHrAssistantFeature } from '@core/intelligence-smart-ui';
import { AskHrChatFeatureId } from '@tellent-ask-hr/core-types';
import { TicketsChatService } from '@tellent-ask-hr/tickets-logic';
import {
  ChatUserTicketsViewComponent,
  TicketsWelcomeComponent,
} from '@tellent-ask-hr/tickets-smart-ui';

export const CHAT_TICKETS_FEATURE = provideHrAssistantFeature({
  useValue: {
    id: AskHrChatFeatureId.Tickets,
    welcomeCmp: TicketsWelcomeComponent,
    welcomeCmpVisible: () => inject(TicketsChatService).isFeatureAvailable(),
    activateCmp: ChatUserTicketsViewComponent,
  },
});
